// extracted by mini-css-extract-plugin
module.exports = {"main_container":"TagChip_main_container__60uvh","tag_chip_text":"TagChip_tag_chip_text__27_BA"};